import { Expose } from "class-transformer";
import { ICmsPagination } from "./cms-pagination.entity.interface";

export class CmsPagination implements ICmsPagination {
  @Expose()
  page!: number;

  @Expose()
  pageCount!: number;

  @Expose()
  pageSize!: number;

  @Expose()
  total!: number;
}
